import { useMemo } from 'react';
import type { IFormControl } from '@orbitalwatch/design';

const noop = () => {};

/**
 * The DS `FormField*` components take an `IFormControl` (from DS `useFormControl`) that owns
 * value, validation and disabled state. The screens keep their state in plain
 * `useState` + explicit `valid` flags, so `Field` synthesises a read-only control from its
 * props instead of moving every screen onto `useFormControl`. Only the presentation bits
 * (`hasErrors`, `errorMessages`, `isDisabled`) are meaningful; `value`/`setValue` are inert.
 */
export function useFieldControl(options: { error?: string | null; disabled?: boolean }): IFormControl<unknown> {
    const { error, disabled } = options;
    return useMemo(() => ({
        value: undefined,
        setValue: noop,
        errorMessages: error ? [error] : [],
        isValid: !error,
        isDisabled: !!disabled,
        setIsDisabled: noop,
        hasErrors: !!error,
        validate: () => !error,
    }), [error, disabled]);
}
